import { RouteObject, Navigate } from "react-router-dom";
import AuthGate from "@/components/AuthGate";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/login/page";
import HomePage from "@/pages/home/page";
import DashboardPage from "@/pages/dashboard/page";
import LeadsPage from "@/pages/leads/page";
import LeadDetailPage from "@/pages/leads/LeadDetail";
import PartnersPage from "@/pages/partners/page";
import PartnerDetailPage from "@/pages/partners/PartnerDetail";
import PartnerNewPage from "@/pages/partners/PartnerNew";
import OffersPage from "@/pages/offers/page";
import OfferDetailPage from "@/pages/offers/OfferDetail";
import VerticalsPage from "@/pages/verticals/page";
import VerticalDetailPage from "@/pages/verticals/VerticalDetail";
import GeosPage from "@/pages/geos/page";
import PayoutsPage from "@/pages/finance/payouts/page";
import InvoicesPage from "@/pages/finance/invoices/page";
import InvoiceDetailPage from "@/pages/finance/invoices/InvoiceDetail";
import InvoiceNewPage from "@/pages/finance/invoices/InvoiceNew";
import DisputesPage from "@/pages/finance/disputes/page";
import FinanceSummaryPage from "@/pages/finance/summary/page";
import ReportsPage from "@/pages/reports/page";
import SharedReportPage from "@/pages/reports/SharedReport";
import CapacityPage from "@/pages/capacity/page";
import AuditLogPage from "@/pages/audit-log/page";
import SettingsPage from "@/pages/settings/page";
import PartnerLeadsPage from "@/pages/partner/leads/page";
import PartnerLeadDetailPage from "@/pages/partner/leads/LeadDetail";
import PartnerQuotesPage from "@/pages/partner/quotes/page";
import PartnerBillingPage from "@/pages/partner/billing/page";
import PartnerPerformancePage from "@/pages/partner/performance/page";
import PartnerCapacityPage from "@/pages/partner/capacity/page";
import PartnerDashboardPage from "@/pages/partner/dashboard/page";
import PartnerCataloguePage from "@/pages/partner/catalogue/page";
import PartnerAgendaPage from "@/pages/partner/agenda/page";
import PartnerAdsPage from '@/pages/partner/ads/page';
import PartnerNovaPage from "@/pages/partner/nova/page";
import SemmyPage from "@/pages/partner/semmy/page";
import SemmyDebugPage from "@/pages/partner/semmy/debug";
import SemmyIdentityPage from "@/pages/partner/semmy/identity";
import PartnerSettingsPage from "@/pages/partner/settings/page";
import QuoteSigningPage from "@/pages/signing/QuoteSigningPage";
import InstallationSchedulingPage from "@/pages/scheduling/InstallationSchedulingPage";
import DeliveryApprovalPage from "@/pages/public/DeliveryApproval";
import ProjectTrackerPage from "@/pages/public/ProjectTracker";
import LeadLandingPage from "@/pages/public/LeadLandingPage";
import PartnerLandingPage from "@/pages/public/PartnerLanding";
import DebugPage from "@/pages/debug/page";
import GoogleCallbackPage from "@/pages/auth/GoogleCallback";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/offerte/:token",
    element: <QuoteSigningPage />,
  },
  {
    path: "/inplannen/:token",
    element: <InstallationSchedulingPage />,
  },
  {
    path: "/oplevering/:token",
    element: <DeliveryApprovalPage />,
  },
  {
    path: "/project/:token",
    element: <ProjectTrackerPage />,
  },
  {
    path: "/partner-landing",
    element: <PartnerLandingPage />,
  },
  {
    path: "/lead",
    element: <LeadLandingPage />,
  },
  {
    path: "/lead/:partner",
    element: <LeadLandingPage />,
  },
  {
    path: "/auth/google/callback",
    element: <GoogleCallbackPage />,
  },
  {
    element: (
      <AuthGate>
        <Layout />
      </AuthGate>
    ),
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/nova", element: <HomePage /> },
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/leads", element: <LeadsPage /> },
      { path: "/leads/:id", element: <LeadDetailPage /> },
      { path: "/partners", element: <PartnersPage /> },
      { path: "/partners/new", element: <PartnerNewPage /> },
      { path: "/partners/:id", element: <PartnerDetailPage /> },
      { path: "/offers", element: <OffersPage /> },
      { path: "/offers/:id", element: <OfferDetailPage /> },
      { path: "/verticals", element: <VerticalsPage /> },
      { path: "/verticals/:verticalId", element: <VerticalDetailPage /> },
      { path: "/geos", element: <GeosPage /> },
      { path: "/finance/payouts", element: <PayoutsPage /> },
      { path: "/finance/invoices", element: <InvoicesPage /> },
      { path: "/finance/invoices/new", element: <InvoiceNewPage /> },
      { path: "/finance/invoices/:id", element: <InvoiceDetailPage /> },
      { path: "/finance/disputes", element: <DisputesPage /> },
      { path: "/finance/summary", element: <FinanceSummaryPage /> },
      { path: "/reports", element: <ReportsPage /> },
      { path: "/reports/shared/:token", element: <SharedReportPage /> },
      { path: "/capacity", element: <CapacityPage /> },
      { path: "/audit-log", element: <AuditLogPage /> },
      { path: "/settings", element: <SettingsPage /> },
      { path: "/debug", element: <DebugPage /> },
      { path: "/partner", element: <PartnerDashboardPage /> },
      { path: "/partner/nova", element: <PartnerNovaPage /> },
      { path: "/partner/inbox", element: <Navigate to="/partner/leads" replace /> },
      { path: "/partner/leads", element: <PartnerLeadsPage /> },
      { path: "/partner/leads/:id", element: <PartnerLeadDetailPage /> },
      { path: "/partner/quotes", element: <PartnerQuotesPage /> },
      { path: "/partner/payouts", element: <PartnerBillingPage /> },
      { path: "/partner/performance", element: <PartnerPerformancePage /> },
      { path: "/partner/capacity", element: <PartnerCapacityPage /> },
      { path: "/partner/catalogue", element: <PartnerCataloguePage /> },
      { path: "/partner/agenda", element: <PartnerAgendaPage /> },
      { path: "/partner/ads", element: <PartnerAdsPage /> },
      { path: "/partner/semmy", element: <SemmyPage /> },
      { path: "/partner/semmy/debug", element: <SemmyDebugPage /> },
      { path: "/partner/semmy/identity", element: <SemmyIdentityPage /> },
      { path: "/partner/settings", element: <PartnerSettingsPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;